export default "__VITE_ASSET__7432e6f5__"